import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Suspense, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/custom-toast.css";
// auth provider

import routes, { renderRoutes } from './routes';
import AdminLayout from './layouts/AdminLayout';

const App = () => {
  return (
    <React.Fragment>
        {/* <ToastContainer /> */}
      {/* <BrowserRouter basename={process.env.REACT_APP_BASE_NAME}>{renderRoutes(routes)}</BrowserRouter> */}
      <BrowserRouter>
        <ToastContainer />
        <Suspense fallback={<div></div>}>
          <Routes>
            {routes?.map((route, index) => {       
              return (
                <Route
                  key={index}
                  exact
                  path={route.path}
                  element={route?.private ? <AdminLayout title={route?.title}>{route?.element}</AdminLayout> :route.element}
                />
              );
            })}
          </Routes>
        </Suspense>
      </BrowserRouter>
    </React.Fragment>
  );
};

export default App;
